<script setup lang="ts">
</script>
<template>
    <div class="template-root">
        <global-menu >
            <template #slot-contents>
                <slot/>
            </template>
        </global-menu>
    </div>
</template>
